import { useFocusRing } from '@react-aria/focus';
import React, { useRef, useMemo } from 'react';
import { useRadio } from '@react-aria/radio';
import { mergeProps, useId } from '@react-aria/utils';
import { useHover } from '@react-aria/interactions';
import { VisuallyHidden } from '../visually-hidden/index.js';
import { RadioButtonLabelElement, RadioButtonInputElement, RadioButtonParagraphElement, RadioButtonDescriptionElement, } from './radio-group.styles.js';
import { useRadioGroupContext } from './radio-group-context.component.js';
export const RadioButton = React.forwardRef(({ children, lang, className, style, dataAutomation, description, ...props }, ref) => {
    const state = useRadioGroupContext();
    const radioRef = useRef(null);
    const { inputProps, isDisabled, isSelected } = useRadio({ ...props, children }, state, radioRef);
    const { isFocused, isFocusVisible, focusProps } = useFocusRing();
    const interactionDisabled = isDisabled || state.isReadOnly;
    const { hoverProps, isHovered } = useHover({
        isDisabled: interactionDisabled,
    });
    const uniqueDataAutomation = useMemo(() => dataAutomation ||
        ['radio-button', props.id || ''].filter(Boolean).join('-'), [dataAutomation, props.id]);
    const labelId = useId();
    const descriptionId = useId();
    return (React.createElement(React.Fragment, null,
        React.createElement(RadioButtonLabelElement, { isSelected: isSelected, isDisabled: isDisabled, isHovered: isHovered, isFocused: isFocused, isFocusVisible: isFocusVisible, "data-automation": uniqueDataAutomation, ...hoverProps, lang: lang, className: className, style: style, ref: ref },
            React.createElement(VisuallyHidden, null,
                React.createElement(RadioButtonInputElement, { ...mergeProps(inputProps, focusProps), ref: radioRef, "data-automation": `${uniqueDataAutomation}/input/${isSelected ? 'active' : 'inactive'}`, "aria-labelledby": labelId, "aria-describedby": description ? descriptionId : undefined })),
            React.createElement(RadioButtonParagraphElement, { id: labelId }, children),
            description && (React.createElement(RadioButtonDescriptionElement, { id: descriptionId }, description)))));
});
//# sourceMappingURL=radio-button.component.js.map